import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_2 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_3 = { class: "table-wrap row mb-3" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table table-borderless mb-0 font-12" }
const _hoisted_6 = { class: "table-light nowrap-text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("th", null, "...", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 5 }
const _hoisted_17 = { key: 6 }
const _hoisted_18 = { key: 7 }
const _hoisted_19 = {
  key: 8,
  class: "text-danger",
  colspan: "4"
}
const _hoisted_20 = {
  key: 9,
  colspan: "4"
}
const _hoisted_21 = { class: "badge badge-dim badge-warning" }
const _hoisted_22 = { key: 10 }
const _hoisted_23 = { key: 11 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    (_ctx.payerContractor)
      ? (_openBlock(), _createBlock("h6", _hoisted_1, [
          _createVNode("strong", null, _toDisplayString(_ctx.$t('payer_contractor_payment_history')), 1)
        ]))
      : (_openBlock(), _createBlock("h6", _hoisted_2, [
          _createVNode("strong", null, _toDisplayString(_ctx.$t('contractor_sub_contractor_payment_history')), 1)
        ])),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("table", _hoisted_5, [
          _createVNode("thead", _hoisted_6, [
            _createVNode("tr", null, [
              _createVNode("th", null, _toDisplayString(_ctx.$t('date')), 1),
              _createVNode("th", null, _toDisplayString(_ctx.$t('payment_type')), 1),
              _createVNode("th", null, _toDisplayString(_ctx.$t('amount')), 1),
              _createVNode("th", null, _toDisplayString(_ctx.$t('remarks')), 1),
              _createVNode("th", null, _toDisplayString(_ctx.$t('status')), 1),
              _hoisted_7
            ])
          ]),
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.history, (history, paymentIndex) => {
              return (_openBlock(), _createBlock("tr", { key: paymentIndex }, [
                (history.status_id === 3 || history.status_id === 4 || history.status_id === 1)
                  ? (_openBlock(), _createBlock("td", _hoisted_8, _toDisplayString(history.created_at), 1))
                  : _createCommentVNode("", true),
                (history.status_id === 3 || history.status_id === 4)
                  ? (_openBlock(), _createBlock("td", _hoisted_9, [
                      (history.type === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_10, "Partial"))
                        : (history.type === 2)
                          ? (_openBlock(), _createBlock("span", _hoisted_11, "Percentage"))
                          : (_openBlock(), _createBlock("span", _hoisted_12, "Full"))
                    ]))
                  : (_openBlock(), _createBlock("td", _hoisted_13, "-")),
                (history.status_id === 3 && history.payment.amount || history.status_id === 4 )
                  ? (_openBlock(), _createBlock("td", _hoisted_14, "$ " + _toDisplayString(history.payment.amount), 1))
                  : (history.status_id === 1 && history.amount)
                    ? (_openBlock(), _createBlock("td", _hoisted_15, "$ " + _toDisplayString(history.amount), 1))
                    : _createCommentVNode("", true),
                (history.status_id === 3 || history.status_id === 4 && history.detail)
                  ? (_openBlock(), _createBlock("td", _hoisted_16, _toDisplayString(history.detail), 1))
                  : _createCommentVNode("", true),
                (history.status_id === 3 && history.payment.detail || history.status_id === 4)
                  ? (_openBlock(), _createBlock("td", _hoisted_17, _toDisplayString(history.payment.detail), 1))
                  : (_openBlock(), _createBlock("td", _hoisted_18, "-")),
                (history.status_id === 2)
                  ? (_openBlock(), _createBlock("td", _hoisted_19, _toDisplayString(_ctx.$t('last_payment_request_on')) + " " + _toDisplayString(history.created_at) + " " + _toDisplayString(_ctx.$t('was_denied')), 1))
                  : _createCommentVNode("", true),
                (history.status_id === 1)
                  ? (_openBlock(), _createBlock("td", _hoisted_20, [
                      _createTextVNode(_toDisplayString(_ctx.$t('last_payment_request_on')) + " ", 1),
                      _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('pending')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (history.status_id === 3 && history.payment.amount)
                  ? (_openBlock(), _createBlock("td", _hoisted_22, [
                      _createVNode("button", {
                        class: "btn default-btn outline d-inline-block",
                        onClick: ($event: any) => (_ctx.acknowledgePayment(history))
                      }, _toDisplayString(_ctx.$t('acknowledge')), 9, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (history.status_id === 4)
                  ? (_openBlock(), _createBlock("td", _hoisted_23, _toDisplayString(_ctx.$t('acknowledged')), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}